import { SystemService } from '../../core/system/system.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Router } from '@angular/router';

import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';

import { IamService } from '../../module/iam/iam.service';
import { SignedInResultModel } from '../../module/iam/login/model/signed-in-result.model';

@Injectable({ providedIn: 'root' })
export class SessionService {
    private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

    constructor(
        private systemService: SystemService,
        private iamService: IamService,
        private router: Router
    ) {}

    public renew(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isUserIdle = this.systemService.isUserIdle();
        const sessionId = this.systemService.getLocalStorage('sessionId')!

        if (isUserIdle || !sessionId) {
            this.logoutAndRedirect();
            return throwError(() => new Error('Sessão expirada por inatividade.'));
        }

        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            return this.iamService.refreshSession(sessionId).pipe(
                switchMap((result: SignedInResultModel) => {
                    this.isRefreshing = false;
                    this.systemService.setSignInInformation(result);

                    const newToken = result.session.token;
                    this.refreshTokenSubject.next(newToken);

                    return next.handle(this.addTokenHeader(request, newToken));
                }),
                catchError((err) => {
                    this.isRefreshing = false;
                    this.logoutAndRedirect();
                    return throwError(() => err);
                })
            );
        } else {
            return this.refreshTokenSubject.pipe(
                filter(token => token !== null),
                take(1),
                switchMap(token => {
                    return next.handle(this.addTokenHeader(request, token as string));
                })
            );
        }
    }

    public logoutAndRedirect(): void {
        const currentNav = this.router.getCurrentNavigation();
        let returnUrl = this.router.url;

        if (currentNav) {
            returnUrl = currentNav.extractedUrl.toString();
        }

        if (!returnUrl.includes('/sign/in')) {
            this.systemService.signOut(returnUrl);
        } else {
            this.systemService.signOut('');
        }
    }

    private addTokenHeader(request: HttpRequest<any>, token: string): HttpRequest<any> {
        return request.clone({
            setHeaders: {
                Authorization: token
            }
        });
    }
}
